import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-minus': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM316 384C322.6 384 328 378.6 328 372V332C328 325.4 322.6 320 316 320H132C125.4 320 120 325.4 120 332V372C120 378.6 125.4 384 132 384H316z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-minus.js
// module id = bodb
// module chunks = 144